export default __webpack_public_path__ + "static/media/7_4.d684edba.png";